// extracted by mini-css-extract-plugin
export var deleteIcon = "_sf-5";
export var deleteOption = "_sf-3";
export var divider = "_sf-2";
export var downloadIcon = "_sf-4";
export var drawer = "_sf-0";
export var drawerFooter = "_sf-6";
export var drawerOpen = "_sf-1";
export var highlighted = "_sf-7";
export var lighterHighlight = "_sf-8";